import React, { useCallback, useEffect, useState } from 'react';
import UserList from '../../components/List/Manage/UserList';
import { Link } from 'react-router-dom';
import { Modal, Pagination, Upload } from 'antd';
import Input from '../../components/Input/Input';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { resetChangePasswordUser, resetGetUserEmployersDistribution } from '../../redux/slices/user.slice';
import { toast } from 'react-toastify';
import { changePasswordUser } from '../../redux/actions/user/changePasswordUser';
import Loading from '../../components/Loading/Loading';
import { getAdminList } from '../../redux/actions/user/getAdminList';
import { getManagerList } from '../../redux/actions/user/getManagerList';
import { getMe } from '../../redux/actions/user/getMe';
import { getUserEmployersDistribution } from '../../redux/actions/user/getUserEmployersDistribution';
import SelectionPerformer from '../SelectionPerformer';
import { axiosInstance } from '../../utils/axiosInterceptor';
import EmployersDistributionView from '../../components/EmployersDistribution/EmployersDistributionView';

const items = [
  {
    key: 1,
    name: 'Куликова Александра Мироновна',
  },
  {
    key: 2,
    name: 'Андреева Василиса Матвеевна',
  },
  {
    key: 3,
    name: 'Пахомов Александр Романович',
  },
  {
    key: 4,
    name: 'Крючкова Милана Артёмовна',
  },
  {
    key: 5,
    name: 'Гусев Макар Артёмович',
  },
];

const toIntegerOrNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || !Number.isInteger(numericValue)) {
    return null;
  }

  return numericValue;
};

const formatQuotaValue = (value) => (Number.isInteger(value) ? value : '—');

function UserManageIndex() {
  const [adminManage, setAdminManage] = useState(true);
  const [managerManage, setManagerManage] = useState(true);
  const [counterPartyManage, setCounterPartyManage] = useState(true);
  const [editState, setEditState] = useState(false);
  const [nameState, setName] = useState('Иванов Иван Иванович');
  const [userState, setUser] = useState('ivanov');
  const [passwordState, setPassword] = useState('iuhew9809w');
  const [fileList, setFileList] = useState([]);
  const [freeEmployersCount, setFreeEmployersCount] = useState(0);
  const [isFreeEmployersModalOpen, setIsFreeEmployersModalOpen] = useState(false);
  const [isDistributionModalOpen, setIsDistributionModalOpen] = useState(false);
  const [adminCurrentPage, setAdminCurrentPage] = useState(1);
  const [adminPageSize, setAdminPageSize] = useState(10);
  const [managerCurrentPage, setManagerCurrentPage] = useState(1);
  const [managerPageSize, setManagerPageSize] = useState(10);
  const [devVacancyAccessUserId, setDevVacancyAccessUserId] = useState('');
  const [devVacancyAccessLoading, setDevVacancyAccessLoading] = useState(false);
  const {
    getMe: { data: getMeData, error: getMeError, loading: getMeLoading },
  } = useSelector((state) => state.user);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleAdmin = () => {
    setAdminManage(!adminManage);
  };

  const handleManager = () => {
    setManagerManage(!managerManage);
  };

  const handleCounterParty = () => {
    setCounterPartyManage(!counterPartyManage);
  };

  const handleEdit = () => {
    setEditState(true);
  };

  const handleSave = () => {
    setEditState(false);
  };

  const handleChange = (e) => {
    if (e.target.name === 'name') {
      setName(e.target.value);
    } else if (e.target.name === 'user') {
      setUser(e.target.value);
    } else {
      setPassword(e.target.value);
    }
  };

  const form = useForm({
    defaultValues: {
      password: '',
      new_password: '',
    },
  });
  const dispatch = useDispatch();
  const {
    getAdminList: { data: getAdminListData, error: getAdminListError, loading: getAdminListLoading },
    getManagerList: { data: getManagerListData, error: getManagerListError, loading: getManagerListLoading },
    getUserEmployersDistribution: { data: employersDistributionData, loading: employersDistributionLoading, error: employersDistributionError },
  } = useSelector((state) => state.user);
  const currentUserId = getMeData?.id;
  const isSuperuser = getMeData?.is_superuser === true;
  const isSuperAdminAdmin = isSuperuser && getMeData?.role === 'admin';
  const ownOriginalQuota = toIntegerOrNull(getMeData?.original_quota);
  const ownAvailableQuota = toIntegerOrNull(getMeData?.max_employers);
  const ownAssignedEmployers = Number.isFinite(Number(getMeData?.assigned_employers)) ? Number(getMeData?.assigned_employers) : 0;
  const ownDistributedEmployers = Number.isFinite(Number(getMeData?.distributed_employers)) ? Number(getMeData?.distributed_employers) : 0;
  const ownContractorsTotal = ownAssignedEmployers + ownDistributedEmployers;
  const ownContractorsAvailable = ownAssignedEmployers;
  const ownLimitsTotalDisplay = toIntegerOrNull(getMeData?.max_employers) ?? ownOriginalQuota;
  const ownAvailableEmployersDisplay = toIntegerOrNull(getMeData?.available_employers) ?? ownAvailableQuota;
  const ownContractorsTotalDisplay = toIntegerOrNull(getMeData?.total_employers) ?? ownContractorsTotal;
  const ownContractorsAvailableDisplay = toIntegerOrNull(getMeData?.available_employers) ?? ownContractorsAvailable;
  const ownContractorsFreeDisplay = toIntegerOrNull(getMeData?.free_employers) ?? ownContractorsAvailableDisplay;
  const isEmployersViewBlockedByMeData = !isSuperAdminAdmin && !currentUserId;
  const adminTotal = Number(getAdminListData?.count) || 0;
  const managerTotal = Number(getManagerListData?.count) || 0;

  const fetchFreeEmployersCount = useCallback(async () => {
    if (!isSuperAdminAdmin && !currentUserId) {
      setFreeEmployersCount(0);
      return;
    }

    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_API}/employers/`, {
        params: isSuperAdminAdmin ? { responsible_is_null: true, has_access: false, page: 1 } : { responsible_id: currentUserId, page: 1 },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      setFreeEmployersCount(Number(response?.data?.count) || 0);
    } catch (error) {
      setFreeEmployersCount(0);
    }
  }, [isSuperAdminAdmin, currentUserId]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (!getMeData) {
      return;
    }

    setAdminCurrentPage(1);
    setManagerCurrentPage(1);
  }, [getMeData?.id, getMeData?.is_superuser]);

  useEffect(() => {
    if (!getMeData?.is_superuser) {
      return;
    }

    dispatch(
      getAdminList({
        page: adminCurrentPage,
      }),
    );
  }, [dispatch, getMeData?.is_superuser, adminCurrentPage]);

  useEffect(() => {
    if (!getMeData) {
      return;
    }

    if (!isSuperuser && !currentUserId) {
      return;
    }

    dispatch(
      getManagerList({
        page: managerCurrentPage,
        ...(!isSuperuser && { descendant_of: currentUserId }),
      }),
    );
  }, [dispatch, getMeData, isSuperuser, currentUserId, managerCurrentPage]);

  useEffect(() => {
    const resultsLength = getAdminListData?.results?.length;
    if (adminCurrentPage === 1 && Number.isFinite(resultsLength) && resultsLength > 0) {
      setAdminPageSize(resultsLength);
    }
  }, [getAdminListData?.results, adminCurrentPage]);

  useEffect(() => {
    const resultsLength = getManagerListData?.results?.length;
    if (managerCurrentPage === 1 && Number.isFinite(resultsLength) && resultsLength > 0) {
      setManagerPageSize(resultsLength);
    }
  }, [getManagerListData?.results, managerCurrentPage]);

  useEffect(() => {
    fetchFreeEmployersCount();
  }, [fetchFreeEmployersCount]);

  const onSubmit = (data) => {
    dispatch(changePasswordUser(data));
  };
  const {
    changePasswordUser: { data: changePasswordUserData, error: changePasswordUserError, loading: changePasswordUserLoading },
  } = useSelector((state) => state.user);
  useEffect(() => {
    if (changePasswordUserData) {
      toast.success('Пароль успешно изменен', { theme: 'colored', autoClose: '3000' });
      form.reset();
      handleSave();
      dispatch(resetChangePasswordUser());
    }
  }, [changePasswordUserData]);
  useEffect(() => {
    return () => {
      dispatch(resetChangePasswordUser());
      dispatch(resetGetUserEmployersDistribution());
    };
  }, [dispatch]);

  const getErrorMessage = (error, fallbackText) => {
    if (!error) {
      return fallbackText;
    }

    if (typeof error === 'string') {
      return error;
    }

    if (typeof error?.detail === 'string') {
      return error.detail;
    }

    if (Array.isArray(error?.detail) && error.detail.length) {
      return error.detail.join(', ');
    }

    if (typeof error?.message === 'string') {
      return error.message;
    }

    const firstFieldError = Object.values(error).find((value) => (Array.isArray(value) && value.length > 0) || typeof value === 'string');

    if (Array.isArray(firstFieldError)) {
      return firstFieldError[0];
    }

    if (typeof firstFieldError === 'string') {
      return firstFieldError;
    }

    return fallbackText;
  };

  const handleDevGrantViewAnyVacancy = async () => {
    const parsedUserId = Number(devVacancyAccessUserId);
    if (!Number.isInteger(parsedUserId) || parsedUserId <= 0) {
      toast.error('Введите корректный ID пользователя', { theme: 'colored', autoClose: '3000' });
      return;
    }

    setDevVacancyAccessLoading(true);
    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_API}/users/${parsedUserId}/permissions`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });

      const normalizedPermissions = Array.isArray(response?.data) ? response.data : Array.isArray(response?.data?.results) ? response.data.results : [];
      const permissionNames = new Set(
        normalizedPermissions
          .map((permissionItem) => {
            if (typeof permissionItem === 'string') {
              return permissionItem;
            }
            return permissionItem?.name;
          })
          .filter(Boolean),
      );

      permissionNames.add('view_any_vacancy');
      const permissionPayload = Array.from(permissionNames).map((name) => ({ name }));

      await axiosInstance.put(`${process.env.REACT_APP_SERVER_API}/users/${parsedUserId}/permissions`, permissionPayload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });

      toast.success(`Пользователю ${parsedUserId} выдано право view_any_vacancy`, { theme: 'colored', autoClose: '3000' });
    } catch (error) {
      toast.error(getErrorMessage(error?.response?.data, 'Не удалось выдать право view_any_vacancy'), { theme: 'colored', autoClose: '3000' });
    } finally {
      setDevVacancyAccessLoading(false);
    }
  };

  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <div className="container relative flex flex-1 flex-col mx-auto max-w-[1163px]">
        <div className="flex flex-col w-full gap-3">
          <div className="flex w-full px-4 lg:px-0">
            <h2 className="text-[25px] font-normal text-black">Управление</h2>
          </div>
          <div className="flex w-full ">
            <div className="flex flex-col first:flex-row w-full gap-3 ">
              <div className="flex w-full first:w-[20%] mb-2 justify-center ">
                {!editState ? (
                  <div className="bg-[#E5E5E5] w-[160px] h-[160px] m-5 flex items-center justify-center rounded-lg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
                      <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
                    </svg>
                  </div>
                ) : (
                  <div className="flex justify-center items-center">
                    <Upload action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188" listType="picture-card" fileList={fileList} onChange={onChange} onPreview={onPreview}>
                      {fileList.length < 1 && 'ВыгрузитьЬ'}
                    </Upload>
                  </div>
                )}
              </div>
              <div className="flex flex-col w-full first:w-[50%] mb-2 p-5 gap-3 ">
                <div className="">{!editState ? <label className="text-lg">{getMeData?.full_name}</label> : <></>}</div>
                <div className="">{!editState ? <label className="text-lg">{getMeData?.email?.split('@')?.[0]}</label> : <></>}</div>

                {editState && (
                  <>
                    {' '}
                    <Input form={form} type={'password'} name="password" placeholder={'Старый пароль'} disabled={changePasswordUserLoading} error={changePasswordUserError?.['password']?.[0]} />{' '}
                    <Input form={form} type={'password'} name="new_password" placeholder={'Новый пароль'} className="mt-1" disabled={changePasswordUserLoading} error={changePasswordUserError?.['new_password']?.[0]} />
                  </>
                )}
                <div class="relative">
                  {changePasswordUserLoading && <Loading className="absolute top-[135%] lg:top-[19px] left-1/2 lg:left-[132px] transform -translate-x-1/2 -translate-y-1/2" />}

                  {editState ? (
                    <>
                      <button disabled={changePasswordUserLoading} type="button" onClick={form.handleSubmit(onSubmit)} className="text-center text-[14px] border rounded py-2 px-4 mb-2 text-white  mr-2 w-full break-words p-2 lg:w-fit hover:bg-[#069488] bg-[#00B2A4] h-[41.6px]">
                        Cохранить
                      </button>{' '}
                      <button
                        onClick={() => {
                          setEditState(false);
                        }}
                        type="button"
                        className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full  bg-white transition ease-in-out duration-300 lg:w-fit w-full">
                        Отмена
                      </button>
                    </>
                  ) : (
                    <button type="button" onClick={handleEdit} className="text-center text-[14px] border rounded py-2 px-4 mb-2 text-white  mr-2 w-full break-words p-2 lg:w-fit hover:bg-[#069488] bg-[#00B2A4]">
                      Редактировать
                    </button>
                  )}
                  {changePasswordUserError?.[0] && <div class="text-red-500 text-center text-sm text-start">{changePasswordUserError?.[0]}</div>}
                </div>
              </div>
              <div className="flex flex-col w-full first:w-[30%] mb-2 p-5 gap-3">
                <div className="rounded-md border border-gray-200 bg-white p-4 space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="rounded-md border border-gray-200 p-3 pt-0 text-sm">
                      <p className="text-sm font-medium text-gray-400 mb-1">Лимиты</p>
                      <p className="font-medium text-gray-800">Ваш</p>
                      <p className="text-gray-600 mt-1">Лимит: {isSuperuser ? '∞' : formatQuotaValue(ownLimitsTotalDisplay)}</p>
                      {isSuperAdminAdmin && <p className="text-gray-600">Доступно: {isSuperuser ? '∞' : formatQuotaValue(ownAvailableEmployersDisplay)}</p>}
                    </div>
                    <div className="rounded-md border border-gray-200 p-3 pt-0 text-sm">
                      <p className="text-sm font-medium text-gray-400 mb-1">Контрагенты</p>
                      <p className="font-medium text-gray-800">Ваши</p>
                      {isSuperAdminAdmin ? (
                        <>
                          <p className="text-gray-600 mt-1">Лимит: {isSuperuser ? '∞' : formatQuotaValue(ownContractorsTotalDisplay)}</p>
                          <p className="text-gray-600">Доступно: {isSuperuser ? '∞' : formatQuotaValue(ownContractorsAvailableDisplay)}</p>
                        </>
                      ) : (
                        <p className="text-gray-600 mt-1">Свободно: {formatQuotaValue(ownContractorsFreeDisplay)}</p>
                      )}
                    </div>
                  </div>

                  <button
                    type="button"
                    className="text-center border rounded py-2 px-4 text-white bg-button hover:bg-button-hov transition ease-in-out duration-300 disabled:opacity-50 w-full"
                    disabled={getMeLoading || isEmployersViewBlockedByMeData}
                    onClick={() => {
                      fetchFreeEmployersCount();
                      setIsFreeEmployersModalOpen(true);
                    }}>
                    Свободные контрагенты ({freeEmployersCount})
                  </button>
                  <button
                    type="button"
                    className="w-full text-center border rounded py-2 px-4 text-gray-700 border-gray-300 bg-gray-100 hover:bg-gray-200 hover:text-gray-900 transition ease-in-out duration-300 disabled:opacity-50"
                    disabled={getMeLoading || isEmployersViewBlockedByMeData}
                    onClick={() => {
                      if (!currentUserId) {
                        return;
                      }
                      dispatch(getUserEmployersDistribution(currentUserId));
                      setIsDistributionModalOpen(true);
                    }}>
                    Подробнее
                  </button>
                </div>
              </div>
            </div>
          </div>
          {getMeData?.is_superuser && (
            <div className="flex flex-col w-full gap-3">
              <div className="flex flex-col 468:flex-row justify-between align-middle mt-2 gap-3 px-4 lg:px-0">
                <label className="text-lg underline cursor-pointer" onClick={handleAdmin}>
                  Администраторы
                </label>
                <Link to={`/add/admin`}>
                  <button type="button" className="text-center border rounded py-2 px-4 mb-2 bg-button text-white hover:bg-button-hov mr-2 w-full 468:w-fit transition ease-in-out duration-300">
                    Добавить администратора
                  </button>
                </Link>
              </div>
              {adminManage ? (
                <div className="px-4">
                  <div className="flex flex-col w-full p-4 border-1 border-[#C4C4C4] shadow-lg">
                    <UserList currentItems={getAdminListData?.results} />
                    {adminTotal > adminPageSize && (
                      <div className="flex justify-center mt-4">
                        <Pagination current={adminCurrentPage} total={adminTotal} pageSize={adminPageSize} showSizeChanger={false} disabled={getAdminListLoading} onChange={setAdminCurrentPage} />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          )}

          <div className="flex flex-col w-full gap-3 pb-8">
            <div className="flex flex-col 468:flex-row justify-between align-middle mt-2 gap-3 px-4 lg:px-0">
              <label className="text-lg underline cursor-pointer" onClick={handleManager}>
                Менеджеры
              </label>
              <Link to={`/add/manager`}>
                <button type="button" className="text-center border rounded py-2 px-4 mb-2 bg-button text-white hover:bg-button-hov mr-2 w-full 468:w-fit transition ease-in-out duration-300">
                  Добавить менеджера
                </button>
              </Link>
            </div>
            {managerManage ? (
              <div className="px-4">
                <div className="flex flex-col w-full p-4 border-1 border-[#C4C4C4] shadow-lg">
                  <UserList currentItems={getManagerListData?.results} />
                  {managerTotal > managerPageSize && (
                    <div className="flex justify-center mt-4">
                      <Pagination current={managerCurrentPage} total={managerTotal} pageSize={managerPageSize} showSizeChanger={false} disabled={getManagerListLoading} onChange={setManagerCurrentPage} />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        destroyOnClose
        open={isFreeEmployersModalOpen}
        width={'100%'}
        onCancel={() => {
          setIsFreeEmployersModalOpen(false);
        }}
        footer={['']}>
        <SelectionPerformer
          readOnly
          mode="employers-free"
          title={`Свободные контрагенты (${freeEmployersCount})`}
          sliceName="employer"
          actionName="getEmployerList"
          fetchParams={isSuperAdminAdmin ? { has_access: false } : { responsible_id: currentUserId ?? -1 }}
          onClose={() => {
            setIsFreeEmployersModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        className="select-user-modal"
        style={{ height: 'calc(100vh - 40px)' }}
        title={``}
        centered
        destroyOnClose
        open={isDistributionModalOpen}
        width={'100%'}
        onCancel={() => {
          setIsDistributionModalOpen(false);
        }}
        footer={['']}>
        <EmployersDistributionView
          data={employersDistributionData}
          loading={employersDistributionLoading}
          error={employersDistributionError}
          isManageSuperAdminView={isSuperAdminAdmin}
          onRefreshDistribution={() => {
            if (!currentUserId) {
              return;
            }
            dispatch(getUserEmployersDistribution(currentUserId));
            fetchFreeEmployersCount();
          }}
        />
      </Modal>
    </div>
  );
}

export default UserManageIndex;
